<script setup lang="ts">
  import { FormInput, SimpleLoading } from '@/shared/ui';
  import RememberMeCheck from './RememberMeCheck.vue';
  import ChangePasswordForm from './ChangePasswordForm.vue';
  import { useLogin } from '../model/useLogin';
  import { NO_SPACES_MASK } from '@/shared/lib/mask';

  const {
    form,
    errors,
    rememberMe,
    isLoginLoading,
    mustChangePassword,
    handleBlurUsername,
    handleBlurPassword,
    handleSubmit,
  } = useLogin();
</script>
<template>
  <ChangePasswordForm v-if="mustChangePassword" />
  <div
    v-else
    class="w-2/3"
  >
    <div class="pb-8">
      <h1 class="text-4xl/11 mb-2 font-semibold">
        Login
      </h1>
      <p class="text-sm/5 text-gray-03">
        Insira seu nome de usuário cadastrado e senha para entrar
      </p>
    </div>
    <form
      class="flex flex-col gap-6 text-sm/5"
      @submit.prevent="handleSubmit"
    >
      <FormInput
        id="username"
        v-model="form.username"
        label="Usuário"
        type="text"
        placeholder="Insira seu nome de usuário aqui"
        :error="errors.username"
        :mask="NO_SPACES_MASK"
        @blur="handleBlurUsername"
      />
      <FormInput
        id="password"
        v-model="form.password"
        label="Senha"
        type="password"
        placeholder="Insira sua senha aqui"
        :error="errors.password"
        :is-password="true"
        @blur="handleBlurPassword"
      />
      <RememberMeCheck v-model="rememberMe" />
      <button
        type="submit"
        data-testid="login-submit-btn"
        class="flex items-center justify-center bg-black text-white rounded-md py-3 px-4"
        :disabled="isLoginLoading"
      >
        <span v-if="!isLoginLoading">Entrar</span>
        <SimpleLoading
          v-else
          :track-color="'white-01'"
        />
      </button>
      <p>Ainda não tem uma conta? Entre em contato com a T.I.</p>
    </form>
  </div>
</template>
